
import { defineComponent } from '@vue/composition-api';
import { LiveEventsEvent, PreviewEventGroup } from '../../../../types/sport';
import IllinoisCollapsible from './Collapsible.vue';
import EventItem from './EventItem.vue';
import { formattedDate } from '@/composables/utils';

export default defineComponent({
  name: 'EventGroup',
  components: {
    IllinoisCollapsible,
    EventItem
  },
  props: {
    eventGroup: {
      type: Object as () => LiveEventsEvent[] | PreviewEventGroup,
      required: true
    },
    sportId: {
      type: String,
      default: ''
    },
    categoryId: {
      type: String,
      default: ''
    },
    tournamentId: {
      type: String,
      default: ''
    },
    baseUrl: {
      type: String,
      default: '/live'
    },
    currentLanguage: {
      type: String,
      default: ''
    },
    darkMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isLiveGroup(): boolean {
      return Array.isArray(this.eventGroup);
    },
    groupTitle(): string {
      if (this.isLiveGroup) {
        const liveGroup = this.eventGroup as LiveEventsEvent[];
        return liveGroup[0]?.tournamentName || '';
      } else {
        const prematchGroup = this.eventGroup as PreviewEventGroup;
        return formattedDate(prematchGroup.scheduled);
      }
    },
    eventsList(): any[] {
      if (this.isLiveGroup) {
        return this.eventGroup as LiveEventsEvent[];
      } else {
        const prematchGroup = this.eventGroup as PreviewEventGroup;
        return prematchGroup.events || [];
      }
    },
    language(): string {
      return (
        this.currentLanguage ||
        (this.$store.getters['settings/getLanguage'] as string) ||
        'en'
      );
    }
  },
  methods: {
    getSportId(event: any): string {
      if (this.sportId) {
        return this.sportId;
      }
      if (this.isLiveGroup && event.sportId != null) {
        return event.sportId.toString();
      }
      return '';
    },
    getCategoryId(event: any): string {
      if (this.categoryId) {
        return this.categoryId;
      }
      if (this.isLiveGroup && event.categoryId != null) {
        return event.categoryId.toString();
      }
      return '';
    },
    getTournamentId(event: any): string {
      if (this.tournamentId) {
        return this.tournamentId;
      }
      if (this.isLiveGroup && event.tournamentId != null) {
        return event.tournamentId.toString();
      }
      return '';
    }
  }
});
